function bindAll (dictionary, binding) {
  const mod = {};

  Object.keys(dictionary).forEach((name) => {
    if (typeof dictionary[name] === 'function') {
      mod[name] = dictionary[name].bind(binding);
    } else {
      mod[name] = bindAll(dictionary[name], binding);
    }
  });

  return mod;
}

export class Hermes {
  constructor ({ $axios, modules }) {
    this.$axios = $axios;

    Object.keys(modules).forEach((name) => {
      this[name] = bindAll(modules[name], this);
    });
  }
}

export const Api = {
  install (_Vue) {
    if (!('$api' in _Vue.prototype)) {
      Object.defineProperty(_Vue.prototype, '$api', {
        get () {
          return this.$root._api;
        },
      });

      _Vue.mixin({
        beforeCreate () {
          if (this.$options.api !== undefined) {
            this._api = this.$options.api;
          }
        },
      });
    }
  },
};
